import { Link } from 'react-router-dom';

import USACS_LOGO from './../../../assets/images/USACS-logo.png';
import AccountMenu from './AccountMenu';
import { LogoWrapper, TopbarWrapper } from './Topbar.styled';

function Topbar() {
  return (
    <TopbarWrapper>
      <Link to="/">
        <LogoWrapper>
          <img src={USACS_LOGO} alt="USACS-logo" />
        </LogoWrapper>
      </Link>

      <AccountMenu />
    </TopbarWrapper>
  );
}
export default Topbar;
